import { CheckOutcome } from "./checkOutcome";

/**
 * Outcome counts. `total` is `passed + failed`; no-data outcomes are counted
 * separately and never included in it.
 * @public
 */
export interface Tally {
  passed: number;
  failed: number;
  noData: number;
  total: number;
}

/** @public */
export const EMPTY_TALLY: Tally = Object.freeze({
  passed: 0,
  failed: 0,
  noData: 0,
  total: 0,
});

/** @public */
export function tally(outcomes: Iterable<CheckOutcome>): Tally {
  let passed = 0;
  let failed = 0;
  let noData = 0;
  for (const outcome of outcomes) {
    if (outcome === "pass") passed += 1;
    else if (outcome === "fail") failed += 1;
    else noData += 1;
  }
  return { passed, failed, noData, total: passed + failed };
}

/** @public */
export function addTallies(a: Tally, b: Tally): Tally {
  return {
    passed: a.passed + b.passed,
    failed: a.failed + b.failed,
    noData: a.noData + b.noData,
    total: a.total + b.total,
  };
}

/** Passed over total, from 0 to 1; undefined when nothing passed or failed. @public */
export function passRate(
  t: Pick<Tally, "passed" | "total">
): number | undefined {
  return t.total === 0 ? undefined : t.passed / t.total;
}

/** The whole percentage shown for a pass rate. @public */
export function ratePercent(rate: number | undefined): number | undefined {
  return rate === undefined ? undefined : Math.round(rate * 100);
}
